import { styled } from 'styled-components';
import PaymentOption from './PaymentOption.js';
export default PaymentOption;
export const PaymentId = styled.h4 `
  &,
  span {
    text-align: center;
    font-size: 0.9em;
    font-family: 'Courier New', Courier, monospace !important;
    font-weight: bold;
  }

  svg {
    width: 13px;
    height: 13px;
    margin: 0.2em 0.1em -0.2em -0.3em;
  }
`;
//# sourceMappingURL=index.js.map